import { useContext } from "react";
import UserDataPreferenceForm from "../UserDataPreferenceForm";
import { UserDataPreferenceContext } from "..";
import Styles from '../Styles.module.css'

export default function TargetedAdsOptInView(){
  const { setTitle } = useContext(UserDataPreferenceContext);
  setTitle("Residents Outside of NJ, PA, MI - Opt Back Into Targeted Advertising")

  return (
    <>
      <p>
        To opt back into targeted advertising for residents outside of New Jersey, Pennsylvania, or Michigan, 
        please enter your information below and click submit.
      </p>
      <p>
        For more information about our Privacy Notice, <a href="/privacy-policy" className={Styles.link}>click here</a>.
      </p>
      <UserDataPreferenceForm 
        successMessage={"You have been opted-in. Thank you."} 
        enableEmail={true} 
        dataType="Advertising" 
        status="Opt In"
      />
    </>
  )
}